export const hasPermission = (object = null, action = null) => {
  const permissionsList = sessionStorage.getItem("rolePermissionsList");
  const permissions = permissionsList ? JSON.parse(permissionsList) : null;
  if (!permissions || !permissions.requestdefinitions) return false;
  if (!object && !action) return false;
  const foundObject = permissions?.requestdefinitions.find(
    definition => definition.object.toLowerCase() === object.toLowerCase()
  );
  if (!foundObject) return false;
  if (action) {
    const actionObject = foundObject?.actions.find(actionObj => actionObj.action === action);
    return actionObject?.isenabled ?? false;
  }
  return true;
};
